const SHARED_ROUTES = {
  public: {
    login: '/login',
    singingOidc: '/signin-oidc',
  },
};

export default SHARED_ROUTES;
